export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_RE = /^[+0-9][0-9\s\-()]{6,19}$/;

export function Field({ label, htmlFor, required, error, children }) {
  return (
    <div className="space-y-1.5">
      <label htmlFor={htmlFor} className="block text-sm font-semibold text-navy">
        {label} {required && <span className="text-gold-600" aria-hidden="true">*</span>}
      </label>
      {children}
      {error && (
        <p role="alert" className="text-xs font-medium text-red-700" data-testid={`${htmlFor}-error`}>
          {error}
        </p>
      )}
    </div>
  );
}

const baseInput =
  "w-full rounded-md border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 transition-colors focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/40";

export function TextInput(props) {
  return <input {...props} className={baseInput} />;
}

export function SelectInput({ children, ...props }) {
  return (
    <select {...props} className={baseInput}>
      {children}
    </select>
  );
}

export function TextArea(props) {
  return <textarea rows={4} {...props} className={`${baseInput} resize-y`} />;
}

export function validateCommon(values, fields) {
  const errors = {};
  fields.forEach((f) => {
    if (!values[f] || !String(values[f]).trim()) errors[f] = "This field is required.";
  });
  if (values.email && !EMAIL_RE.test(values.email)) errors.email = "Enter a valid email address.";
  if (values.phone && !PHONE_RE.test(values.phone)) errors.phone = "Enter a valid phone number.";
  return errors;
}
